import { ICursorElements } from '@/store/types/search.types';
import { fetchQuery } from '@/utils/queryClient';
import { THttpMethod, fetchMethods } from '@/types/FetchService.types';
import { TAdvancedRoleSlug } from '@/features/roles/store/models/advancedRole.model';

import { createHttpHeader } from '@/utils/network/createHTTPHeaders';

import { decryptTreezorResponse } from './encryption/decryptTreezorResponse';
import { TBaseDecryptOptions, TCursorDecryptOptions, TSingleDecryptOptions } from './types/encryption';

type TFetchParams = {
  url: string;
  method?: THttpMethod;
  contentType?: string;
  body?: any;
  isStringify?: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protectedEndPoint?: boolean;
  searchParams?: URLSearchParams | { [key: string]: any };
  action?: string;
  userRole?: TAdvancedRoleSlug;
};

export function isSearchParams(object: any): object is URLSearchParams {
  return object.constructor.name === 'URLSearchParams';
}

export async function get<T>(params: TFetchParams, decryptOptions?: TBaseDecryptOptions): Promise<T[]>;
export async function get<T>(params: TFetchParams, decryptOptions?: TSingleDecryptOptions): Promise<T>;
export async function get<T>(params: TFetchParams, decryptOptions?: TCursorDecryptOptions): Promise<ICursorElements<T>>;
export async function get<T>(
  params: TFetchParams,
  decryptOptions?: TBaseDecryptOptions | TSingleDecryptOptions | TCursorDecryptOptions,
): Promise<T | T[] | ICursorElements<T> | void> {
  const {
    method = fetchMethods.GET,
    url,
    body,
    searchParams,
    contentType = 'application/json',
    isStringify = true,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    protectedEndPoint = true,
    action,
  } = params;

  let queryParams = {};

  if (body === undefined) {
    if (searchParams !== undefined) {
      if (isSearchParams(searchParams)) {
        queryParams = Object.fromEntries(searchParams);
      } else {
        queryParams = searchParams;
      }
    }
  } else {
    queryParams = isStringify ? JSON.stringify(body) : body;
  }

  const response = await fetchQuery(['Fetch Service', { method, action, params: queryParams }], url, {
    ...(protectedEndPoint && { headers: createHttpHeader(contentType) }),
    ...(body && { body: isStringify ? JSON.stringify(body) : body }),
    staleTime: 0,
    userRole: params.userRole,
  });

  return await decryptTreezorResponse<T>(response, decryptOptions);
}
